import { SOURCE_NOT_AVAILABLE } from 'app/lib/constants';
import type { TableType } from 'app/lib/types/server';
import {
    DATA_SOURCE_REFERENCE_DTO_TYPE,
    GENERIC_TRANSFORM_TYPE,
    TRANSFORMATION_STACK_DTO_TYPE
} from 'app/store/__generated__/types';

type ViewEntity = {
    _type: string;
    sourceType?: TableType;
    deployedAs?: TableType;
    operationUids?: string[];
    payload?: {
        type: string;
    };
    transformationsByUid?: Record<string, { _type: string }>;
};

export function resolveFlowTypeForViewEntity(entity?: ViewEntity) {
    if (!entity) {
        return null;
    }

    switch (entity._type) {
        case DATA_SOURCE_REFERENCE_DTO_TYPE:
            return entity.sourceType || SOURCE_NOT_AVAILABLE;
        case TRANSFORMATION_STACK_DTO_TYPE:
            if (entity.operationUids) {
                if (entity.operationUids.length === 1) {
                    return entity.transformationsByUid?.[entity.operationUids[0]!]!._type;
                }
            }
            return TRANSFORMATION_STACK_DTO_TYPE;
        case GENERIC_TRANSFORM_TYPE:
            if (entity.payload) {
                return entity.payload.type;
            }
            return entity._type;
        default:
            return entity._type;
    }
}
